import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isContactsLastName(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CONTACTS_LAST_NAME && typeof label === 'string' && typeof value === 'string';
}
function _formatContactsLastName(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatContactsLastName(submission) {
  if (isContactsLastName(submission)) {
    return _formatContactsLastName(submission);
  }
  return undefined;
}
//# sourceMappingURL=contacts-last-name-preview.js.map